'use client';

import { useEffect } from 'react';
import { trackBlogPostViewed } from '@/lib/analytics/events';

interface BlogPostTrackerProps {
  slug: string;
  title?: string;
}

export default function BlogPostTracker({ slug, title }: BlogPostTrackerProps) {
  useEffect(() => {
    trackBlogPostViewed(slug, title);
  }, [slug, title]);

  return null;
}

